module.exports = __webpack_public_path__ + "img/002-psd.b7810b43.svg";